export default __webpack_public_path__ + "static/media/up.de95d135.png";